import React from "react";
import _ from "underscore";
import Carousel from "react-bootstrap/Carousel";
import ReactHtmlParser from "react-html-parser";

const PromoMessages = ({promo_messages}) => {
    return (
        <Carousel
            interval={5000}
            controls={false}
            indicators={promo_messages && promo_messages.length > 1}
        >
            { _.map(promo_messages, (message, key) => {
                return (
                    <Carousel.Item key={key}>
                        {ReactHtmlParser(message)}
                    </Carousel.Item>
                )
            })}
        </Carousel>
    )
}

export default PromoMessages;